// extracted by mini-css-extract-plugin
export default {"info":"MoreCustomers_info__eyS6r","btns":"MoreCustomers_btns__g8JXs","button":"MoreCustomers_button__-IlW6"};